

import { SubDomain } from "../SubDomain";
import CheckIn from "./CheckIn";

export default class CheckInsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, CheckIn.MODEL_NAME);
    this.storage = storage;
  }

  findById(objId) {
    var object = this.storage.map[objId];
    return new CheckIn(this.domain, object);
  }
}